import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { toast } from "sonner";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Registers the service worker for offline app-shell caching and
// "Add to Home Screen" installability. Scan/account API calls are never
// cached (see src/service-worker.js) so results always stay live.
//
// Without the onUpdate hook below, a new service worker only ever reaches
// the "waiting" state - it never takes over an already-open tab/installed
// PWA window, so anyone who installed the app before a fix shipped keeps
// running the old cached bundle indefinitely, silently missing every later
// fix until they happen to fully quit and relaunch it.
//
// An earlier version of this fix force-called skipWaiting() and reloaded
// the page the instant a new build took over - but that can happen at any
// moment, including mid-interaction (an open dialog or dropdown menu),
// where an unannounced page reload looks exactly like the UI "flashing and
// closing" for no reason. Instead, only show a toast letting the user
// choose when to refresh - the update still reaches them, just on their
// own schedule instead of interrupting whatever they're doing.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (!registration.waiting) return;
    toast("A new version of Honey Scanner is ready.", {
      duration: Infinity,
      action: {
        label: "Refresh",
        onClick: () => {
          navigator.serviceWorker.addEventListener(
            "controllerchange",
            () => window.location.reload(),
            { once: true },
          );
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
        },
      },
    });
  },
});
